import { FC, ReactNode, createContext, useContext } from 'react';

/**
 * Feedback context value that can be provided by consumers to render
 * feedback UI (e.g. thumbs up/down) within SDUI expandable sections.
 */
export interface SDUIFeedbackContextValue {
  /** Render feedback UI for an expandable section; receives a generic metadata bag (e.g. { title, description }) */
  renderFeedback?: (metadata: Record<string, unknown>) => ReactNode;
}

const SDUIFeedbackContext = createContext<SDUIFeedbackContextValue | null>(
  null,
);

export interface SDUIFeedbackProviderProps {
  children: ReactNode;
  value: SDUIFeedbackContextValue;
}

export const SDUIFeedbackProvider: FC<SDUIFeedbackProviderProps> = ({
  children,
  value,
}) => {
  return (
    <SDUIFeedbackContext.Provider value={value}>
      {children}
    </SDUIFeedbackContext.Provider>
  );
};

/**
 * Hook to access the optional SDUI feedback context.
 * Returns null if no provider is present.
 */
export const useSDUIFeedbackContext = (): SDUIFeedbackContextValue | null => {
  return useContext(SDUIFeedbackContext);
};
